import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@icon/plus.svg'


const _hoisted_1 = { class: "to-do-view__layers" }
const _hoisted_2 = { class: "to-do__filters" }
const _hoisted_3 = { class: "to-do__menu" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "to-do__summary" }
const _hoisted_6 = ["aria-pressed", "onClick"]
const _hoisted_7 = { class: "to-do__summary-copy" }
const _hoisted_8 = { class: "to-do__summary-count" }
const _hoisted_9 = {
  key: 0,
  class: "to-do__list-loader"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "content__box-shadow" }, null, -1)
const _hoisted_11 = {
  key: 2,
  class: "to-do__empty"
}
const _hoisted_12 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseHeading = _resolveComponent("BaseHeading")!
  const _component_BasicCheckbox = _resolveComponent("BasicCheckbox")!
  const _component_icon = _resolveComponent("icon")!
  const _component_ToDoListSkeleton = _resolveComponent("ToDoListSkeleton")!
  const _component_ToDoItem = _resolveComponent("ToDoItem")!
  const _component_SpinnerDots = _resolveComponent("SpinnerDots")!
  const _component_Observer = _resolveComponent("Observer")!
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_ToDoContent = _resolveComponent("ToDoContent")!
  const _component_ToDoDetails = _resolveComponent("ToDoDetails")!
  const _component_ToDoAdd = _resolveComponent("ToDoAdd")!
  const _directive_scroll = _resolveDirective("scroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.expandToDo)
      ? (_openBlock(), _createBlock(_component_ToDoContent, {
          key: 0,
          class: _normalizeClass([_ctx.className, "to-do-view"])
        }, {
          header: _withCtx(() => [
            _createVNode(_component_BaseHeading, {
              level: "2",
              color: "monochrome-06"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" ToDo Items ")
              ]),
              _: 1
            })
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.toDoMenu, (item) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: item.id,
                    type: "button",
                    class: _normalizeClass(["to-do__menu__item", { 'is-active': _ctx.selectedMenuItem === item.id }]),
                    onClick: ($event: any) => (_ctx.onSelectMenuItem(item.id))
                  }, _toDisplayString(item.label) + ": " + _toDisplayString(_ctx.formatToDoCount(item.count)), 11, _hoisted_4))
                }), 128))
              ]),
              _createVNode(_component_BasicCheckbox, {
                modelValue: _ctx.showCompleted,
                class: "to-do__show-completed",
                label: "Show Completed",
                value: "showCompleted",
                checkType: "switch",
                lineThrough: false,
                "onUpdate:modelValue": _ctx.onToggleCompleted
              }, null, 8, ["modelValue", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryStats, (stat) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: stat.id,
                  type: "button",
                  class: _normalizeClass(["to-do__summary-item", { 'is-active': _ctx.filterToDo[stat.id] }]),
                  "aria-pressed": Boolean(_ctx.filterToDo[stat.id]),
                  onClick: ($event: any) => (_ctx.onSelectSummaryStat(stat.id))
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_icon, {
                      data: stat.icon,
                      width: "var(--icon-16)",
                      height: "var(--icon-16)",
                      color: stat.color
                    }, null, 8, ["data", "color"]),
                    _createElementVNode("span", null, _toDisplayString(stat.label), 1)
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatToDoCount(stat.count)), 1)
                ], 10, _hoisted_6))
              }), 128))
            ]),
            (_ctx.$wait.is('get.todos'))
              ? (_openBlock(), _createBlock(_component_ToDoListSkeleton, { key: 0 }))
              : (_ctx.toDos.length)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_Observer, {
                      id: "to-do-view-list",
                      key: _ctx.selectedMenuItem,
                      class: "to-do__item__list custom-scroll",
                      items: _ctx.toDos,
                      last: _ctx.isLast,
                      options: _ctx.observerOptions,
                      onIntersect: _ctx.scroll,
                      onOnMounted: _ctx.scrollToSelectedElement
                    }, {
                      default: _withCtx(({ item, index }) => [
                        (_openBlock(), _createBlock(_component_ToDoItem, {
                          id: item.id,
                          key: item.id,
                          item: item,
                          index: index,
                          sm: true,
                          isSent: _ctx.selectedMenuItem === 'sent',
                          disableCheckbox: item.owners.every(owner => owner.id !== _ctx.currentUser.id),
                          onOnCheckboxClick: _ctx.onCheckboxClick,
                          onOnEdit: _ctx.onEditToDo,
                          onOnOpen: _ctx.onOpenToDo,
                          onOnRelatedUrlClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onHideToDoWidget')))
                        }, null, 8, ["id", "item", "index", "isSent", "disableCheckbox", "onOnCheckboxClick", "onOnEdit", "onOnOpen"]))
                      ]),
                      after: _withCtx(() => [
                        (_ctx.$wait.is('get.todos.scroll'))
                          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                              _createVNode(_component_SpinnerDots, { size: 6 })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["items", "last", "options", "onIntersect", "onOnMounted"])), [
                      [_directive_scroll, _ctx.handleScroll]
                    ]),
                    _hoisted_10
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_BaseSubHeading, {
                      size: "extra-large",
                      weight: "400",
                      color: "monochrome-05",
                      darkColor: "monochrome-04"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Clean slate — enjoy it while it lasts ")
                      ]),
                      _: 1
                    }),
                    _createElementVNode("img", {
                      src: require(`@/assets/images/picture_cup${_ctx.isDark ? '_dark' : ''}.png`),
                      alt: "",
                      class: "to-do__empty-image"
                    }, null, 8, _hoisted_12)
                  ]))
          ]),
          footer: _withCtx(() => [
            _createElementVNode("button", {
              id: "to-do-add-button",
              type: "button",
              class: "link is-large to-do__add-button",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('addToDo')), ["prevent"]))
            }, [
              _createVNode(_component_icon, {
                data: _imports_0,
                fill: true,
                width: "var(--icon-24)",
                height: "var(--icon-24)"
              }),
              _createTextVNode(" ToDo ")
            ])
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.openedToDo)
      ? (_openBlock(), _createBlock(_component_ToDoDetails, {
          key: 1,
          id: "to-do-details",
          item: _ctx.openedToDo,
          onBack: _ctx.onCloseDetails,
          onEdit: _ctx.onEditToDo,
          onOnCheckboxClick: _ctx.onCheckboxClick
        }, null, 8, ["item", "onBack", "onEdit", "onOnCheckboxClick"]))
      : _createCommentVNode("", true),
    (_ctx.expandToDo)
      ? (_openBlock(), _createBlock(_component_ToDoAdd, {
          key: 2,
          id: "to-do-edit",
          className: "to-do__edit",
          onOnCancel: _ctx.onCloseToDo
        }, null, 8, ["onOnCancel"]))
      : _createCommentVNode("", true)
  ]))
}